// extracted by mini-css-extract-plugin
export default {"banner":"InstallBanner_banner__bOc7L","icon":"InstallBanner_icon__rhGwl","text":"InstallBanner_text__N5NEN","cta":"InstallBanner_cta__DyEiZ","dismiss":"InstallBanner_dismiss__Becyy"};